<template>
  <ul>
    <li
      v-for="(adjustment, index) in sortedAdjustments"
      :key="index"
    >
      <span>({{ adjustment.amount | formatDuration(false, '-', true, true) }}) </span>
      <span>{{ adjustment.reason }}</span>
      on
      <time datetime="adjustment.date">{{ adjustment.date | formatDate }}</time>
      <span v-if="memberNameMap[adjustment.created_by_id]"> by {{ memberNameMap[adjustment.created_by_id] }} </span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'TimeOffBalancesReportManualAdjustments',
  props: {
    manualAdjustments: {
      type: Array,
      required: true,
    },
    members: {
      type: Array,
      required: true,
    },
  },
  computed: {
    sortedAdjustments() {
      return [...this.manualAdjustments].sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });
    },
    memberNameMap() {
      return this.members.reduce((acc, member) => {
        return { ...acc, [member.id]: member.name };
      }, {});
    },
  },
};
</script>
